import { Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { SHARED_MODULES } from '../../../shared.';
import { IChatMessage, PinnedIndicator } from '../../models/chat';
import { MentionParserPipe } from '../../pipes/mention-parser.pipe';

@Component({
	selector: 'ph-chat-pinned-bar',
	templateUrl: './ph-chat-pinned-bar.component.html',
	styleUrls: ['./ph-chat-pinned-bar.component.scss'],
	imports: [
		...SHARED_MODULES,
		MentionParserPipe
	]
})
export class PhChatPinnedBarComponent {

	pinnedIndicators: InputSignal<Array<PinnedIndicator>> = input<Array<PinnedIndicator>>([]);
	currentPinnedMessage: InputSignal<IChatMessage | null> = input<IChatMessage | null>(null);
	currentPinnedIndex: InputSignal<number> = input<number>(-1);

	@Output() headerClick: EventEmitter<void> = new EventEmitter<void>();
}
